import { useContext, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import VehicleService from "../services/VehicleService";
import { set } from "../store/slice/model.response";
import { Model } from "../types/response";
import { AppContext } from "../store/context/AppContext";

const useGetModel = () => {
    const context = useContext(AppContext);
    const dispatch = useAppDispatch();

    const vehicle = useAppSelector(state => state.vehicle.value);

    useEffect(() => {

        if(!vehicle) return;

        const vehicleService = new VehicleService(context.globalApi);

        (async () => {
            await vehicleService.getModel(vehicle).then(res => {
                if(res.ok) {
                    dispatch(set({value : res.parsedBody as Model}));
                }
            }).catch(err => console.log(err));
        })()

    }, []);
}

export default useGetModel;
